var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content text_align_center"},[_c('div',{staticClass:"mx-3"},[_c('h1',{staticClass:"text_align_center"},[_vm._v(_vm._s(this.$route.params.title))]),_vm._v(" "),_c('div',{staticClass:"text_align_left"},[_vm._v("\n            "+_vm._s(this.$route.params.story)+"\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6149bf95","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Story.vue
// module id = null
// module chunks = 